// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zmU1","option":"styles_option__sRBBQ","selected":"styles_selected__2oq6a"};